import { Link } from "react-router-dom";
import { useEvent } from "../context/EventProvider";
import { useT } from "../settings/context";
import { withContext } from "./registry";

/**
 * NOT FOUND.
 *
 * V1 has no such screen: a wrong address — the first thing someone who mistypes a
 * link ever sees — yields a line of raw text, outside the theme, outside the
 * chrome, in hard-coded French. We start by not reproducing that.
 *
 * In phase 2 this joins the family of degraded states (error, empty, offline,
 * real-time lost), all of which are missing from the current product.
 *
 * ⚠️ « HOME » IS THE EVENT'S HOME, `/<alias>`, not the site root: a bare `/` names no
 * event, so the button that should rescue a mistyped link led to a second error
 * screen (bug #266). With no event in the address, `/` is all there is.
 */
export function NotFound() {
  const t = useT();
  const event = useEvent();
  return (
    <section className="page">
      <div className="hero">
        <h2>{t("PAGE_NOT_FOUND", "Cette page n’existe pas")}</h2>
        <p>
          {t(
            "PAGE_NOT_FOUND_DETAIL",
            "Le lien est peut-être incomplet, ou l’événement n’est plus en ligne. Vérifiez l’adresse reçue dans votre invitation.",
          )}
        </p>
      </div>

      <Link className="btn" to={withContext("/", event?.token)}>
        {t("BACK_TO_HOME", "Retour à l'accueil")}
      </Link>
    </section>
  );
}
